import * as USER from '@/store/constants/user';
import {mapActions} from 'vuex';

import DetailBody from './../Detail/DetailBody';

export default {
  name: 'UserDetail',
  data() {
    return {
      user: {}
    }
  },
  components: {
    DetailBody
  },

  methods: {
    ...mapActions({
      delete: USER.ACTION_DELETE,
      getUser: USER.ACTION_GET_USER
    }),

    handleDelete() {
      // show confirmation form before deleting.
      this.delete(this.user).then(() => this.backToList()).catch((err) => console.log(err));
    },

    backToList() {
      this.$router.push({name: 'UserList'});
    }
  },
  created() {
    if (this.$route.params['user']) {
      this.user = this.$route.params['user'];
    } else {
      this.getUser(this.$route.params['id']).then(res => {
        this.user = res.data;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/User/js/detail.js